import React from "react";
import Link from "../MenuItems/Link/Link";
import Unlink from "../MenuItems/Unlink";

const Links = ({ editor, disabled }) => {
	const setHyperLink = (url, newTab = true) => {
		editor
			.chain()
			.focus()
			.extendMarkRange("link")
			.setLink({ href: url, target: newTab ? "_blank" : "" })
			.run();
	};

	return (
		<>
			<div className={`editor-menu-box`}>
				<Link
					onChange={setHyperLink}
					isActive={editor.isActive("link")}
					prevHref={editor.getAttributes("link").href}
					prevNewTab={editor.getAttributes("link").target}
					isDisabled={disabled}
				/>
				<Unlink
					onClick={() => editor.chain().focus().unsetLink().run()}
					isDisabled={disabled || !editor.isActive("link")}
				/>
			</div>
		</>
	);
};

export default Links;
